import React from 'react';
import { Trophy } from 'lucide-react';

const RoundRecapCard = ({ roundRecap }) => {
  const weatherIcons = { sunny: '☀️', cloudy: '☁️', rainy: '🌧️', windy: '💨' };
  const getScoreColor = (score) => score <= 72 ? 'text-green-500' : score <= 85 ? 'text-yellow-500' : 'text-orange-500';

  return (
    <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-lg p-4 mb-3 border-2 border-[#16a34a]">
      <div className="flex items-center mb-3 pb-2 border-b border-gray-700">
        <Trophy className="w-5 h-5 text-[#16a34a] mr-2" />
        <h4 className="text-lg font-bold text-white">Round Recap</h4>
      </div>
      <div className="mb-3">
        <p className="text-white font-bold text-lg">{roundRecap.courseName}</p>
        <p className="text-sm text-gray-400 flex items-center mt-1">
          <span className="mr-2">{weatherIcons[roundRecap.weather] || '☀️'}</span>
          <span className="capitalize">{roundRecap.weather}</span>
        </p>
      </div>
      <div className="grid grid-cols-2 gap-3 mb-3">
        <div className="bg-gray-800 rounded-lg p-3 text-center">
          <p className="text-xs text-gray-400 mb-1">Total Score</p>
          <p className={`text-3xl font-bold ${getScoreColor(roundRecap.score)}`}>{roundRecap.score}</p>
        </div>
        {roundRecap.bestHole && roundRecap.bestHoleScore != null && (
          <div className="bg-gray-800 rounded-lg p-3 text-center">
            <p className="text-xs text-gray-400 mb-1">Best Hole</p>
            <p className="text-2xl font-bold text-[#16a34a]">#{roundRecap.bestHole}</p>
            <p className="text-sm text-gray-400">Score: {roundRecap.bestHoleScore}</p>
          </div>
        )}
      </div>
      {roundRecap.notes && (
        <div className="bg-gray-800 rounded-lg p-3">
          <p className="text-xs font-bold text-gray-400 mb-1">Notes</p>
          <p className="text-sm text-white">{roundRecap.notes}</p>
        </div>
      )}
    </div>
  );
};

export default RoundRecapCard;
